var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgElevatorinline = function SvgElevatorinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "elevator_inline_svg__Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 50 50"
    },
    viewBox: "3 0 50 50"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".elevator_inline_svg__st1{fill:#08aa90}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elevator_inline_svg__XMLID_155_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elevator_inline_svg__XMLID_10513_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elevator_inline_svg__XMLID_10514_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elevator_inline_svg__XMLID_10515_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elevator_inline_svg__XMLID_10516_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elevator_inline_svg__XMLID_10517_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "elevator_inline_svg__XMLID_10518_",
    d: "M23 17.6c-.1.1-.3.1-.4 0l-.7-.7-.7.7c-.1.1-.3.1-.4 0-.1-.1-.1-.3 0-.4l.9-.9c.1-.1.3-.1.4 0l.9.9c.1.1.1.3 0 .4z",
    className: "elevator_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "elevator_inline_svg__XMLID_10520_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elevator_inline_svg__XMLID_10521_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elevator_inline_svg__XMLID_10522_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "elevator_inline_svg__XMLID_10523_",
    d: "m29 16.7-1 .9c-.1.1-.3.1-.4 0l-.9-.9c-.1-.1-.1-.3 0-.4.1-.1.3-.1.4 0l.7.7.7-.7c.1-.1.3-.1.4 0 .2.1.2.2.1.4z",
    className: "elevator_inline_svg__st1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "elevator_inline_svg__XMLID_10525_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elevator_inline_svg__XMLID_10526_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elevator_inline_svg__XMLID_10527_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "elevator_inline_svg__XMLID_10528_",
    d: "M35.1 13.5v22.1c0 .5-.4 1-1 1-.5 0-1-.4-1-1V14.4H16.8v21.2c0 .5-.4 1-1 1-.5 0-1-.4-1-1V13.5c0-.5.4-1 1-1h18.3c.6 0 1 .4 1 1z",
    className: "elevator_inline_svg__st1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "elevator_inline_svg__XMLID_10530_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elevator_inline_svg__XMLID_10531_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elevator_inline_svg__XMLID_10532_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elevator_inline_svg__XMLID_10533_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "elevator_inline_svg__XMLID_10534_",
    d: "M31.3 19.7v15.9c0 .3-.2.5-.5.5s-.5-.2-.5-.5V20.2h-4.8v15.4c0 .3-.2.5-.5.5s-.5-.2-.5-.5V20.2h-4.8v15.4c0 .3-.2.5-.5.5s-.5-.2-.5-.5V19.7c0-.3.2-.5.5-.5h11.5c.3 0 .6.2.6.5z",
    className: "elevator_inline_svg__st1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "elevator_inline_svg__XMLID_10541_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elevator_inline_svg__XMLID_10542_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elevator_inline_svg__XMLID_10543_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "elevator_inline_svg__XMLID_10544_",
    d: "M32.7 28.1c0 .3-.2.5-.5.5s-.5-.2-.5-.5.2-.5.5-.5.5.2.5.5z",
    className: "elevator_inline_svg__st1"
  }))))))));
};
export default SvgElevatorinline;